import ThemeEnum from '@/enums/themeEnum';
import { isDevMode } from '@/utils/env';
import ModuleProjectSetting from './moduleProjectSetting';
import { GetCoinListTypeEnum } from '@/enums/businessEnum';
import { ContractOpeningUnitEnum } from '../enums/businessEnum';

/**
 * 系统性配置
 * */
export default class ProjectSetting {
  // AES对称加密接密-密钥
  static APP_AES_KEY = 'LhCG1';
  // logo图片配置
  static APP_IMAGE = '';

  // 开启加载页面，这里配置的是开发环境没得，方便开发
  static APP_LODING = !isDevMode();

  //app 名称
  static APP_NAME = 'br2';

  //USDT符号
  static APP_USDT_SYMBOL = '$ ';

  // 是否使用后台配置的语言
  static APP_USE_LANG_FROM_NET = true;

  //默认币种 ,比如日本jpy ，美国ustd
  static APP_DEFAULT_CURRENCY = ' JPY';

  //  股票默认货币符号
  static APP_DEFAULT_CURRENCY_SYMBOL = ' JPY';

  //第三方股票货币符号
  static APP_DEFAULT_SYMBOL = 'R$ ';
  //第三方股票币名称  印度是INR, 巴西是BRL
  static APP_STOCK_SYMBOL = 'RM';

  // 默认主题
  static APP_DEFAULT_THEME = ThemeEnum.light;

  //默认语言 en | ja | zh
  static APP_DEFAULT_LOCALE = 'ja';

  //默认时间格式
  static APP_DEFAULT_TIME_STRING = 'DD-MM-YYYY HH:mm:ss';

  //默认日期
  static APP_DEFAULT_DATE_STRING = 'DD-MM';

  //年月日日期格式
  static APP_DATE_STRING = 'DD-MM-YYYY';

  // 是否开启utc 时间
  static APP_UTC_TIME = true;

  // 是否开启日本时间
  static APP_JP_TIME = false;

  // 是否开启logo
  static App_SHOW_LOGO = true;

  // 是否显示邮箱 登录注册
  static APP_IS_SHOW_EMAIL = true;

  // 日本时间
  static chartTimezone = 'Asia/Tokyo';

  // 盈亏比保留小数
  static PROFITLOSSDECIMAL = 2;

  // 金额小数保留位数
  static amountLen = 2;

  // 是否显示多余的 0
  static showZero: boolean = true;

  // 默认主题
  static APP_DEFAULT_THEME_NAME = ThemeEnum.light;


  // 是否开启极速合约
  static isOpenSpeedContract = false;

  // 是否开启普通合约
  static isOpenCommContract = false;

  // 是否开启外汇合约
  static isOpenForexContract = false;

  // 是否开启极速期货
  static isOpenSpeedFutures = false;

  // 默认合约类型
  static APP_DEFAULT_CONTRACT_TYPE = GetCoinListTypeEnum.CONTRACT;

  // USD精度控制
  static USD_PRECISION = 2;

  // 涨的颜色
  static riseColor = '#2db880';

  // 跌的颜色
  static fallColor = '#C82233';

  // 股票账户是否多币种
  static isShowStockMultiCurrency = true;

  // 多币种 默认币种
  static APP_DEFAULT_CURRENCY_STOCK = 'USD';
  
  // 客服是否脚本注入
  static isCustomerServiceScript = false;

  // 是否需要打开划转【外汇购买】
  static isOpenTransfer = true;

  // 是否开启登录注册隐私协议
  static isOpenPrivacy = false;

  // 是否开启邮箱
  static isOpenEmail = true;

  // 是否开启手机号
  static isOpenPhone = true;

  // 是否开启账号
  static isOpenAccount = true;

  // 默认绿涨红跌
  static upDownColorConfig = 'upGreen';

  // 默认合约开仓单位（张）
  static  defaultContractUnit = ContractOpeningUnitEnum.stretch
}

Object.keys(ModuleProjectSetting).forEach((key:any) => {
  // @ts-ignore
  ProjectSetting[key] = ModuleProjectSetting[key];
})
